// Mock data for basic vessel data tab
// Field IDs must match the 'field' values in vessel-comments.js for version history to work

export const mockBasicVesselData = {
  id: 'basicvesseldata',
  name: 'Basic Vessel Data',
  tables: [
    {
      id: 'principal-dimensions',
      name: 'Principal Dimensions',
      fields: [
        {
          id: 'deadweight',
          name: 'Deadweight',
          measure: 'MT',
          q88data: '115,000',
          responsible: 'Technical',
          q88Reference: 'Q88-DWT-001',
          reference: 'QUES-DWT-001',
        },
        {
          id: 'loa',
          name: 'Length Overall (LOA)',
          measure: 'm',
          q88data: '250.00',
          responsible: 'Technical',
          q88Reference: 'Q88-LOA-001',
          reference: 'QUES-LOA-001',
        },
        {
          id: 'beam',
          name: 'Beam',
          measure: 'm',
          q88data: '44.00',
          responsible: 'Technical',
          q88Reference: 'Q88-BM-001',
          reference: 'QUES-BM-001',
        },
        {
          id: 'draft',
          name: 'Summer Draft',
          measure: 'm',
          q88data: '14.50',
          responsible: 'Technical',
          q88Reference: 'Q88-DFT-001',
          reference: 'QUES-DFT-001',
        },
      ],
      footnote: 'All measurements as per classification society records',
    },
    {
      id: 'capacities',
      name: 'Capacities',
      fields: [
        {
          id: 'cargo-capacity',
          name: 'Cargo Capacity',
          measure: 'CBM',
          q88data: '130,000',
          responsible: 'Operations',
          q88Reference: 'Q88-CC-001',
          reference: 'QUES-CC-001',
        },
        {
          id: 'fuel-capacity',
          name: 'Fuel Oil Capacity',
          measure: 'MT',
          q88data: '3,500',
          responsible: 'Operations',
          q88Reference: 'Q88-FO-001',
          reference: 'QUES-FO-001',
        },
      ],
    },
  ],
}
